<template lang="pug">
b-container(fluid)
    b-row(v-if="projects.length !== 0")
        b-col
            p Showing {{ projects.length }}
            b-table(hover='' 
                v-if='projects.length !== 0'
                :items='projects' :fields='projectFields'
                :select-mode='selectMode'
                ref="projectsTable"
                selectable
                sort-icon-left
                responsive table-class="w-auto"
                @row-selected="onRowSelected")
</template>
    
<script>
import axios from 'axios'
import router from '../router'

const apiBaseUrl = '/scop3ptm/api/'
export default {
    name: 'Projects',
    data: function() {
        return {
            projects: [],
            projectFields: [
                {key: 'projectId', sortable: true},
                {key: 'title'},
                {key: 'disease', sortable: true},
                {key: 'instrument'},
                {
                    key: 'publicationDate',
                    formatter: (value, key, item) => {
                        return item.publicationDate.substring(0, item.publicationDate.indexOf('T'))
                    },
                    sortable: true,
                    sortByFormatted: true
                },
                {key: 'species'},
                {key: 'tissue'},
                {key: 'submissionType'}
            ],
            selectMode: 'single'
        }
    },
    beforeMount: function() {
        if (this.$store.state.proteinId == null) {
            this.getProtein()
        }
        this.getProjects()
    },
    methods: {
        async getProjects() {
            const projectsUrl = apiBaseUrl + 'get-projects'
            const response = await axios
                .get(projectsUrl, {
                    params: {
                        protein_id: this.$store.state.proteinId,
                    }
                })
                .catch(err => {
                    if (err.response) {
                        console.log(err.response)
                    }
                })
            console.log(response)
            this.projects = response.data.projects
        },
        onRowSelected(items) {
            console.log('project selected', items)
            const project_id = items[0].projectId
            router.push({ path: `projects/${project_id}`})
        }
    }
}
</script>

<style lang="scss">
@import '../assets/scss/variables';
</style>